import { priceFormatter } from "@/utils/formatter"
import { TipoPagamento } from "../../../data/tipoPagamento"
import type { Produto } from "../../../types/produto.props"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"

interface AreaComprarProps {
    produto: Produto
    precoPrincipal: number
    exibeValoresSomenteLogado: boolean
}

export function AreaComprar({ produto, precoPrincipal, exibeValoresSomenteLogado }: Readonly<AreaComprarProps>) {
    const valorParcelado = produto.valor_cartao
    const valorPix = produto.valor_pix

    const valor = valorParcelado[5]?.valor ?? valorParcelado[1] ?? produto.valor

    const parcelas = valorParcelado[5]?.parcelas ?? valorParcelado[0]
    const valorParcela = valorParcelado[5]?.valorParcela ?? valorParcelado[2]

    const percentualOff = produto.valor_de > 0 ? 100 - ((valorPix || 0) / produto.valor_de) * 100 : 0
    const desconto = 100 - ((valorPix || 0) / produto.valor) * 100

    return (
        <div className="area-comprar">
            {exibeValoresSomenteLogado ? (
                <div className="valores-logados-vitrine">
                    <span>Faça login para ver os preços</span>

                    <a href="/login" className="btn-comprar-vitrine flex center justify-center">
                        Fazer login
                    </a>
                </div>
            ) : (
                <div className="preco">
                    {produto.valor_de > 0 && (
                        <span className="old-price">
                            de <span>{priceFormatter.format(produto.valor_de)}</span> por
                        </span>
                    )}

                    {precoPrincipal === TipoPagamento.CARTAO ? (
                        <div className="atual">
                            <div className="valor">{priceFormatter.format(valor)}</div>

                            <span className="type-payment">
                                no cartão em {parcelas}x de {priceFormatter.format(valorParcela)}
                            </span>
                        </div>
                    ) : (precoPrincipal === TipoPagamento.PIX && valorPix > 0) ? (
                        <div className="atual">
                            <div className="valor">{priceFormatter.format(valorPix)}</div>

                            {(percentualOff > 5) && (
                                <div
                                    className="icon-desconto"
                                    style={{
                                        backgroundImage: `url(${getResourceFromS3('assets/global/vitrines-landing-page', 'tag-desconto.svg')})`
                                    }}
                                >
                                    {Math.round(percentualOff)}% OFF
                                </div>
                            )}

                            <div className="condicao-pagto">
                                <span>
                                    no pix {Math.round(desconto) > 0 && "com desconto"}
                                </span>
                            </div>
                        </div>
                    ) : (
                        produto.valor_boleto && (
                            <div className="atual">
                                <div className="valor">{priceFormatter.format(produto.valor_boleto)}</div>

                                {produto.valor_de > 0 && (
                                    <div
                                        className="icon-desconto"
                                        style={{
                                            backgroundImage: `url(${getResourceFromS3('assets/global/vitrines-landing-page', 'tag-desconto.svg')})`
                                        }}
                                    >
                                        {Math.round(100 - (produto.valor_boleto / produto.valor_de) * 100)}% OFF
                                    </div>
                                )}

                                <div className="condicao-pagto">
                                    <span>
                                        no boleto{" "}
                                        {Math.round(100 - (produto.valor_boleto / produto.valor) * 100) > 0 &&
                                        "com desconto"}
                                    </span>
                                </div>
                            </div>
                        )
                    )}
                </div>
            )}
        </div>
    )
}
